/**
 * Phase 4.9.1 — Role helpers shared across schedule UI.
 *
 * Single source of truth for role values, labels and styling.
 */
export const ROLES = ["manager", "leader", "new", "regular"];

export const ROLE_ICON = {
  manager: "👑",
  leader: "⭐",
  new: "🆕",
  regular: "",
};

/**
 * Tailwind classes for badge backgrounds. We avoid generating dynamic class
 * names so Tailwind's tree-shaker keeps these in the bundle.
 */
export const ROLE_BADGE_CLASS = {
  manager: "bg-amber-500/20 text-amber-300 border-amber-500/40",
  leader: "bg-emerald-500/20 text-emerald-300 border-emerald-500/40",
  new: "bg-violet-500/20 text-violet-300 border-violet-500/40",
  regular: "",
};

export function roleLabel(t, role) {
  return t(`schedule.role.${role || "regular"}`, { defaultValue: role || "regular" });
}
